/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// React //
import { useEffect, useRef, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom';

// Services //
import { useAuth } from '../../contexts/UserContext';
import { useSidebar } from '../../contexts/SidebarContext';

// Icons //
import { 
  IconButtonArrow, 
  IconButtonArrowDown, 
  IconButtonDots, 
  IconEasyJurLegalOps, 
  IconFavicon,
  IconLogoBig,
  IconUser 
} from '../icons';
import ProfileMenu from '../Ui/ProfileMenu';

// import DropdownItem from '../Ui/DropdownItem';

// Images
import LogoSmallGreen from '../../assets/images/LogoSmallGreen.svg';
import LogoSmallOrange from '../../assets/images/LogoSmallOrange.svg';
import Logo from '../../assets/images/logoLegalOps.svg';
import LogoLegalOps from '../LogoLegalOps';

// Styles //
import { 
    Container,
    Content,
    Header,
    Ul,
    Li,
    SectionFooter,
    ProfileFooter,
    DescriptionProfileFooter,
} from './styles';
import { comum } from '../../styles/Themes/light';

interface SidebarProps {
  list: any;
  forceCollapsed?: boolean;
  onSidebarExpand?: () => void;
  onSidebarToggle?: () => void;
}

export default function Sidebar({ list, forceCollapsed = false, onSidebarExpand, onSidebarToggle }: SidebarProps) {
    const location = useLocation();
    const { user, pageName } = useAuth();
    const { setCollapsed } = useSidebar();
    const openRef = useRef<any>();
    const [ menuSidebar, setMenuSidebar ] = useState(false);
    const [ selected, setSelected ] = useState<any>();
    const [ openMenu, setOpenMenu ] = useState<any>();
    const [ profile, setProfile ] = useState<boolean>();

    function handleOnClickSide(item: any) {
      setSelected(item);
      setMenuSidebar(false);
      
      // Quando clica em um item da sidebar, fecha a sidebar de filtros
      if (onSidebarToggle) {
        onSidebarToggle();
      }
    }

    // Sincroniza estado de colapso com o contexto (para páginas ajustarem largura)
    useEffect(() => {
      setCollapsed(menuSidebar);
    }, [menuSidebar, setCollapsed]);

    // Força o colapso da sidebar quando a sidebar de filtros estiver aberta
    useEffect(() => {
      if (forceCollapsed) {
        setMenuSidebar(true); // true significa colapsada
      }
    }, [forceCollapsed]);

    useEffect(() => {
      if (user?.profile === 'comum') {
        const userWithLetter = `D${user.id}`       

        if (userWithLetter === pageName.split(' ')[1]) {

          setProfile(true);

        } else {

          setProfile(false);

        }
      }

      if (user?.profile === 'operador') {
        const userWithLetter = `P${user.id}`
        
        if (userWithLetter === pageName.split(' ')[1]) {

          setProfile(true);

        } else {

          setProfile(false);

        }
      }

      if (user?.profile === 'admin') {
        const userWithLetter = `J${user.id}`
        
        if (userWithLetter === pageName.split(' ')[1]) {

          setProfile(true);

        } else {

          setProfile(false);

        }
      }

    }, [pageName]) 
    
    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {
            
            if (openMenu && openRef.current && !openRef.current.contains(e.target)) {
                setOpenMenu(false);
            }

        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [openMenu]);

  return (
    <Container
        isAdmin={user?.profile !== 'comum' ? true : false}
        menuSidebar={menuSidebar}
    >
      <Content className='p-4'>
        <Header menuSidebar={menuSidebar} className='gap-3'>
          <div style={{ 
            width: menuSidebar ? 'auto' : 200, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
          }}>
            {menuSidebar ? (
              <button
                type="button"
                onClick={() => {
                  setMenuSidebar(false);
                  // Quando clica na logo para expandir, fecha a sidebar de filtros
                  if (onSidebarToggle) {
                    onSidebarToggle();
                  }
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <IconFavicon />
              </button>
            ) : (
              <LogoLegalOps width={185} style={{ maxWidth: 185, height: 'auto' }} />
            )}
          </div>

          <button
            type="button"
            className="sideButtonBackToPage"
            onClick={() => {
              const newState = !menuSidebar;
              setMenuSidebar(newState);
              
              // Se está expandindo (newState = false), chama o callback
              if (!newState && onSidebarExpand) {
                onSidebarExpand();
              }
            }}
          >
            <IconButtonArrow color="#54666F" />
          </button>
        </Header>
      </Content>
      
      <Ul>
        { list &&
          list.map((row: any) => (
            <Li
              isAdmin={user?.profile !== 'comum' ? true : false}
              menuSidebar={menuSidebar}
              key={row.id}
              hasNotification={row.notification}
              hasSelected={location.pathname === row.to || location.pathname.startsWith(row.to + '/')}
            >
              <Link to={`${row.to}`} onClick={() => handleOnClickSide(row.name)}>
                <div className="sideLiLeft">
                  {row.icon}
                  <h1 className='sideTitleLi'> {row.name} </h1>
                  {/* <div className="sideButtonLi"></div> */}
                </div>

                {/* <div className="sideLiRight">
                  <div
                    className="sideButtonLi"
                    onClick={() => console.log("click")}
                  >
                  </div>
                </div> */}
              </Link>
            </Li>
          ))
        }
        {/* {list.map((row: any) => (
          <DropdownItem
            data={row}
            handleonClick={(to, name) => handleOnActiveButton(to, name)}
            selected={row.name === selected}
          />
        ))} */}
      </Ul>

      <SectionFooter 
        menuSidebar={menuSidebar}
        isAdmin={user?.profile !== 'comum' ? true : false}
        inProfile={profile}
      >
        <ProfileFooter
          menuSidebar={menuSidebar}
          isAdmin={user?.profile !== 'comum' ? true : false} 
          inProfile={profile} 
        >
          <div className="avatarUser">
            {
              profile
            }  <IconUser color="#FFF"/>          
          </div>
          <div 
            className="sideButtonFooter"
            ref={openRef}
            onClick={() => setOpenMenu(!openMenu)}
          > 
            {
              // profile
              //   ? <IconButtonDots color={user?.profile !== 'comum' ? "var(--cf18f00)" : "var(--c00d3ad)"} />
              //   : <IconButtonDots />
              <IconButtonDots color={comum.colors.interfacePure0}/>
            }
            
            {
              openMenu &&
              <ProfileMenu />
            }
          </div>
        </ProfileFooter>

        <DescriptionProfileFooter
          isAdmin={user?.profile !== 'comum' ? true : false}
          menuSidebar={menuSidebar}
          inProfile={profile} 
        >
          <h2>{user?.nome.split(' ')[0]}</h2>
          {
            user?.profile === 'comum' &&
            <span>D{user?.id}</span>
          }
          {
            user?.profile === 'operador' &&
            <span>P{user?.id}</span>
          }
          {
            user?.profile === 'admin' &&
            <span>J{user?.id}</span>
          }
          {
            user?.profile === 'Solicitante' &&
            <span>S{user?.id}</span>
          }
          {
            menuSidebar &&
            <button
              className="sideButtonFooter"
              ref={openRef}
              onClick={() => setOpenMenu(!openMenu)}
            >
              {
                // profile
                //   ? <IconButtonDots color={user?.profile !== 'comum' ? "var(--cf18f00)" : "var(--ce5293f)"} />
                //   : <IconButtonDots color={comum.colors.interfacePure0}/>
                <IconButtonDots color={comum.colors.interfacePure0}/>
              }
              {
                openMenu &&
                <ProfileMenu
                  menuSidebar={menuSidebar}
                />
              }
            </button>
          }
        </DescriptionProfileFooter>


      </SectionFooter>
    </Container>
  );
}